import React, { useState } from "react";

import { Button, DialogContent, DialogActions, Grid, TextField, Switch, Select, MenuItem } from "@material-ui/core";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";

import Label from "../../../../components/Label";
import { categoryEnum } from "../../../../config/category";
import { gradeEnum } from "../../../../config/grade";

import EventApi from "../../../../services/event";

import { Align } from "./styles";
import { eventRoles } from "../../../../utils/Enums";
import { getFirstAndLastNames } from "../../../../utils/Functions";

const CreateGuest = (props) => {
    const [person, setPerson] = useState({
        name: "",
        email: "",
        phone: "",
        certificate: 0,
        enable: true,
        vip: false,
        status_id: 1,
        solicitation_approved: false,
        is_guest: false,
        company: "",
        role: "",
        gender: "",
        cpf: "",
        event_category: "",
        interage_id: "",
    });

    const categoryValues = props.categoryValues;
    const categoryNames = props.categoryNames;
    const gradeValues = props.gradeValues;
    const gradeNames = props.gradeNames;

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }

    const handleChange = (event) => {
        const { checked, name } = event.target;
        setPerson({ ...person, [name]: checked });
    };

    const handleSelect = (event, valuesList, keyName1, keyName2) => {
        const { value } = event.target;
        Object.keys(valuesList).forEach((key) => {
            if (valuesList[key].name === value) {
                setPerson({
                    ...person,
                    [keyName1]: parseInt(key, 10),
                    [keyName2]: value,
                });
            }
        });
    };

    const handleSelectRole = (event) => {
        const { value } = event.target;
        setPerson({
            ...person,
            event_category: value,
        });
    };

    const validFormFields = () => {
        let isValid = true;
        const errors = [];
        Object.entries(person).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            // if (key === "email") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira um endereço de email");
            //     } else if (value.length < 3) {
            //         isValid = false;
            //         errors.push("Insira um endereço de email válido");
            //     }
            // }
            // if (key === "phone") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira um numero para contato");
            //     }
            // }
            // if (key === "company") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira uma instituição");
            //     }
            // }
            // if (key === "cpf") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira seu CPF ou Passaporte");
            //     }
            // }
            // if (key === "birth") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira a data de nascimento");
            //     }
            // }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const newPerson = () => {
        if (!validFormFields()) return;
        EventApi.createPerson({
            ...person,
            cpf: person?.cpf ? person?.cpf?.match(/\d/g)?.join("") : null,
            phone: person?.phone ? person?.phone?.match(/\d/g)?.join("") : null,
            event_id: props.eventData.id,
            grade_id: 1,
            email: person.email.toLowerCase(),
            accepted_terms: true,
            allow_marketing: true,
        })
            .then((resp) => {
                if (!!resp.data) {
                    toast.success("Convidado criado com sucesso!");
                    props.handleClose();
                    window.location.reload();
                } else if (resp?.response?.data?.message && (resp?.response?.data?.message).includes("Already used")) {
                    if ((resp?.response?.data?.message).includes("cpf")) toast.warn("CPF já cadastrado");
                    if ((resp?.response?.data?.message).includes("email")) toast.warn("Email já cadastrado");
                } else toast.warn("Não foi possível concluir a ação");
            })
            .catch(function (error) {
                toast.error(error);
                props.handleClose();
            });
    };

    return (
        <>
            <DialogContent>
                <Grid container justify="space-around" spacing={2}>
                    <Grid item md={12}>
                        <TextField
                            key="name"
                            name="name"
                            required
                            label="Nome Completo"
                            onChange={onChange}
                            value={person.name}
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            key="name_tag"
                            name="name_tag"
                            label="Nome Etiqueta"
                            onChange={onChange}
                            value={person.name_tag || getFirstAndLastNames(person.name)}
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid container justify="space-around" spacing={2}>
                    <Grid item md={6}>
                        <TextField
                            key="email"
                            name="email"
                            label="Email para contato"
                            onChange={onChange}
                            value={person.email}
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            key="cpf"
                            name="cpf"
                            label="Documento"
                            onChange={onChange}
                            value={person.cpf}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid container justify="space-around" spacing={2}>
                    <Grid item md={6}>
                        <TextField
                            key="role"
                            name="role"
                            label="Cargo"
                            onChange={onChange}
                            value={person.role}
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={6}>
                        <InputMask
                            mask="+55 (99) 9 9999-9999"
                            value={person.phone}
                            onChange={onChange}
                            disabled={false}
                            maskChar=""
                            type="text"
                            name="phone"
                        >
                            {() => (
                                <TextField
                                    key="phone"
                                    name="phone"
                                    label="Telefone"
                                    fullWidth
                                    value={person.phone}
                                    onChange={onChange}
                                />
                            )}
                        </InputMask>
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            key="company"
                            name="company"
                            label="Empresa"
                            onChange={onChange}
                            value={person.company}
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid container justify="space-around" spacing={2}>
                    <Grid item md={10}>
                        <label>Categoria:</label>
                        <Select
                            placeholder="Categoria"
                            label="Categoria"
                            name="event_category"
                            fullWidth
                            value={person.event_category}
                            onChange={(e) => handleSelectRole(e)}
                        >
                            {eventRoles.map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                            })}
                        </Select>
                    </Grid>
                    {/* <Grid item md={2}>
                        <Align>
                            <Switch checked={person.vip} onChange={handleChange} name="vip" />
                            <Label>VIP</Label>
                        </Align>
                    </Grid> */}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose} color="primary">
                    cancelar
                </Button>
                <Button
                    onClick={() => {
                        newPerson();
                    }}
                >
                    criar convidado
                </Button>
            </DialogActions>
        </>
    );
};

export default CreateGuest;
